import Routes from "./module/routes";
import Store from "./module/store";

export default {
  name: "scheduler",
  routes: Routes,
  store: Store
};
